export interface IUserUsageStats {
	readonly doneTasks: number;
	readonly pendingTasks: number;
	readonly doneJobMeetings: number;
	readonly pendingJobMeetings: number;
	readonly doneContactMeetings: number;
	readonly pendingContactMeetings: number;
	readonly messagesSent: number;
	readonly messagesLeft: number;
	readonly messagesSentMax: number;
	readonly messagesSentPeriod: number;
}

export class UserUsageStats implements IUserUsageStats {
	private _doneTasks: number;
	private _pendingTasks: number;
	private _doneJobMeetings: number;
	private _pendingJobMeetings: number;
	private _doneContactMeetings: number;
	private _pendingContactMeetings: number;
	private _messagesSent: number;
	private _messagesLeft: number;
	private _messagesSentMax: number;
	private _messagesSentPeriod: number;

	constructor(
		doneTasks: number,
		pendingTasks: number,
		doneJobMeetings: number,
		pendingJobMeetings: number,
		doneContactMeetings: number,
		pendingContactMeetings: number,
		messagesSent: number,
		messagesSentMax: number,
		messagesSentPeriod: number
	) {
		this._doneTasks = doneTasks;
		this._pendingTasks = pendingTasks;
		this._doneJobMeetings = doneJobMeetings;
		this._pendingJobMeetings = pendingJobMeetings;
		this._doneContactMeetings = doneContactMeetings;
		this._pendingContactMeetings = pendingContactMeetings;

		this._messagesSent = messagesSent;
		this._messagesSentMax = messagesSentMax;
		this._messagesSentPeriod = messagesSentPeriod;
		this._messagesLeft = Math.max(messagesSentMax - messagesSent, 0);
	}

	public get doneTasks(): number {
		return this._doneTasks;
	}

	public get pendingTasks(): number {
		return this._pendingTasks;
	}

	public get doneJobMeetings(): number {
		return this._doneJobMeetings;
	}

	public get pendingJobMeetings(): number {
		return this._pendingJobMeetings;
	}

	public get doneContactMeetings(): number {
		return this._doneContactMeetings;
	}

	public get pendingContactMeetings(): number {
		return this._pendingContactMeetings;
	}

	public get messagesSent(): number {
		return this._messagesSent;
	}

	public get messagesLeft(): number {
		return this._messagesLeft;
	}

	public get messagesSentMax(): number {
		return this._messagesSentMax;
	}

	public get messagesSentPeriod(): number {
		return this._messagesSentPeriod;
	}
}
